import {GET_PARTNER_CONFIGS,UPDATE_PARTNER_CONFIGS} from './constants';

export function getPartnerConfigsAction(payload: object) {
  return {
    type: GET_PARTNER_CONFIGS,
    payload,
  };
}


export function updatePartnerConfigs(payload: {
  id: number;
  body: string;
  pagination: object;
}) {
  return {
    type: UPDATE_PARTNER_CONFIGS,
    payload,
  };
}
